<template>
  <div class="">
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="0px"
      size="small"
    >
      <el-form-item label="" prop="content">
        <el-input-number v-model="model.content" :min="1"></el-input-number>
        个工作日
      </el-form-item>
    </el-form>
    <el-button size="small" type="primary" @click="submitForm">保 存</el-button>
  </div>
</template>

<script>
import { getCustomConfig, createCustomConfig } from '@/service/getData';

export default {
  props: {
    type: Number,
  },
  data() {
    return {
      model: {
        type: this.type,
        content: '3',
      },
      rules: {
        content: [
          { required: true, message: '请填写超时时间', trigger: 'change' },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      let res = await getCustomConfig({ type: this.model.type });
      if (res.data.id) {
        this.model = res.data;
      }
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.model.content = this.model.content.toString();
          let res = await createCustomConfig(this.model);
          if (res.code == 0) {
            this.model = res.data;
            this.$message.success('保存成功');
          }
        }
      });
    },
  },
};
</script>
